import usePartner from '../../hooks/usePartner'
import React, { Fragment } from 'react'
import { Box, Divider, Flex, Image, Link, Text } from 'pcln-design-system'
import useHasDisplayPromo from '../../hooks/useHasDisplayPromo'

export function Points() {
  return usePartner('promoService.points') || ''
}
Points.displayName = 'Points'

export function PromoDisplay({ promoNames, children, fallbackChildren }) {
  const hasDisplayPromo = useHasDisplayPromo(promoNames)
  return hasDisplayPromo ? children : fallbackChildren
}
PromoDisplay.displayName = 'PromoDisplay'

export function WrappedFragment({ ...props }) {
  // Wrap Fragment to add displayName without tampering with global React.Fragment.
  return <Fragment {...props} />
}
WrappedFragment.displayName = 'Fragment'

// Missing display names
Text.span.displayName = 'Text.span'

export default [Box, Flex, Image, Link, Text, Text.span, Divider, Points, PromoDisplay, WrappedFragment]
